module.exports = __webpack_public_path__ + "static/media/f_hairstyle_wavy_medium_front.f61ac3d9.png";